module.exports = __webpack_public_path__ + "static/img/headset.2d385ad1.png";